<template>
	<v-row justify="center" class="strength">
		<v-col
			cols="12" sm="6" md="3" lg="3" xl="3"
			v-for="(strength, key) in strengths"
			:key="key"
			data-aos="fade-up"
		>
			<v-row align="center" justify="center">
				<v-col cols="2">
					<v-icon color="accent">mdi-check</v-icon>
				</v-col>
				<v-col cols="10">
					<span class="primary--text">{{ strength }}</span>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
	export default {
		name: "StregthRow",
		data: () => ({
			strengths: [
				"24/7 Access to a doctor",
				"Medical Certificate",
				"E-Prescription"
			]
		})
	}
</script>

<style lang="scss" scoped>
.strength {
	padding-left: 15%;
	padding-right: 15%;

	span {
		font-size: 14px;
		font-weight: bolder;
	}
}
</style>
